(() => {
  const KEY = 'wishlist';
  const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const save = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch {} };

  const paint = () => {
    const list = get();
    document.querySelectorAll('[data-wishlist-handle]').forEach(btn => {
      const on = list.includes(btn.dataset.wishlistHandle);
      const label = on ? '♥' : '♡';
      btn.setAttribute('aria-pressed', on);
      if (btn.textContent !== label) btn.textContent = label;
    });
  };

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    const h = btn.dataset.wishlistHandle;
    const list = get();
    save(list.includes(h) ? list.filter(x => x !== h) : [...list, h]);
    paint();
  });

  let timer;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(paint, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', paint);
})();